<style src="./FormFileInput.scss" lang="scss" scoped></style>
<template>
  <section class="form-file-input">
    <div
      class="drop-zone"
      @dragover="isDragOver"
      @dragenter="isDragOver"
      @dragleave="isDragLeave"
      @dragend="isDragLeave"
      @drop="isDrop"
      :class="{'drop-zone-over': dragOverClass}"
      v-show="uploadStage === 'UPLOAD'">
      <label class="input-label">
        <input
          type="file"
          class="input-file"
          accept=".csv"
          @change="isChoosed">

        <icon-upload class="icon"/>
        <h3>Respositório de arquivo</h3>
        <h5>Arraste o arquivo aqui ou clique para escolher</h5>
      </label>
    </div>

    <div
      class="wait"
      v-show="uploadStage === 'WAIT'">
      <icon-wait class="icon" />
      <h3>Processando o arquivo</h3>
      <h5>Aguarde...</h5>
    </div>

    <section class="command-box">
      <button
      type="button"
      class="btn-default"
      @click="downloadModel">
      Baixar Modelo
    </button>
    </section>
  </section>
</template>

<script>
import FileHandle from './FileHandle'
import http from '@/communication/AuthConnection'
import { IconWait, IconUpload } from '@/components/primitives/icons'

export default {
  name: 'FormFileInput',
  components: {
    IconWait,
    IconUpload
  },
  data () {
    return {
      dragOverClass: false,
      uploadStage: 'UPLOAD'
    }
  },
  methods: {
    isDragOver (e) {
      e.preventDefault()
      e.stopPropagation()

      if (!this.dragOverClass) this.dragOverClass = true
    },
    isDragLeave (e) {
      e.preventDefault()
      e.stopPropagation()

      if (this.dragOverClass) this.dragOverClass = false
    },
    isDrop (e) {
      e.preventDefault()
      e.stopPropagation()
      if (this.dragOverClass) this.dragOverClass = false
      this.readFile(e.dataTransfer.files[0])
    },
    isChoosed (e) {
      e.preventDefault()
      e.stopPropagation()
      this.readFile(e.target.files[0])
    },
    readFile (pFile) {
      if (this.dragOverClass) this.dragOverClass = false
      this.uploadStage = 'WAIT'
      FileHandle(pFile)
        .then((result) => {
          this.uploadStage = 'UPLOAD'
          this.$toasted.success('CMED atualizado com sucesso')
        })
        .catch(() => {
          this.uploadStage = 'UPLOAD'
        })
    },
    downloadModel () {
      http.get('/v1/cmed/download-model', {
        responseType: 'blob'
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'CMED-MODELO.csv')
        document.body.appendChild(link)
        link.click()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/cmed/components/new-cmed/form-file-input/FormFileInput.vue